import { render } from "./OpacityTool.vue?vue&type=template&id=21dea1c3&scoped=true&ts=true"
import script from "./OpacityTool.vue?vue&type=script&lang=ts"
export * from "./OpacityTool.vue?vue&type=script&lang=ts"

import "./OpacityTool.vue?vue&type=style&index=0&id=21dea1c3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dea1c3"]])

export default __exports__